import React from 'react';

export default function HighReturns({ data }) {
    if (!data || data.length === 0) {
        return <p className="text-gray-500 py-4">No high-return items found (threshold: &gt;15% return rate, min 5 shipments).</p>;
    }

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Product</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Shipped (90d)</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Returned</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Return Rate</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Top Reason 1</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Top Reason 2</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Top Reason 3</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {data.map((item, idx) => (
                        <tr key={idx} className="hover:bg-gray-50">
                            <td className="px-3 py-3 text-sm">
                                <div className="font-medium text-gray-900 truncate max-w-[200px]" title={item.productName}>
                                    {item.productName}
                                </div>
                                <div className="text-xs text-gray-400">{item.asin} / {item.sku}</div>
                            </td>
                            <td className="px-3 py-3 text-sm text-right">{item.shippedQty}</td>
                            <td className="px-3 py-3 text-sm text-right font-medium text-red-600">{item.returnedQty}</td>
                            <td className="px-3 py-3 text-sm text-right">
                                <span className={`font-medium ${item.returnRatePct > 25 ? 'text-red-600' : 'text-yellow-600'}`}>
                                    {item.returnRatePct}%
                                </span>
                            </td>
                            <td className="px-3 py-3 text-sm text-gray-600">
                                {item.topReason1 && (
                                    <span>{item.topReason1} ({item.topReason1Count})</span>
                                )}
                            </td>
                            <td className="px-3 py-3 text-sm text-gray-600">
                                {item.topReason2 && (
                                    <span>{item.topReason2} ({item.topReason2Count})</span>
                                )}
                            </td>
                            <td className="px-3 py-3 text-sm text-gray-600">
                                {item.topReason3 && (
                                    <span>{item.topReason3} ({item.topReason3Count})</span>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
